import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ciscoSecureAccess = defineConnector({
  identifier: "ciscoSecureAccess",
  name: "Cisco Secure Access",
  tagLine: "Secure access and cloud security policies",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.sse\\.cisco\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an API key in Cisco Secure Access",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Cisco Secure Access](https://login.sse.cisco.com) as a full admin. Go to **Admin > API Keys**, select the **API Keys** tile, and click **Add**. Give the key a name and select the scopes your workflows need. Include **Policies > Destination Lists** with **Read Only** access (`policies.destinationLists:read`) for the connection test. Choose an expiry date, then click **Create Key**. Copy the API key and secret before closing the dialog; the secret is shown only once.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "Paste your API key",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "API secret",
          placeholder: "Paste your API secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.sse.cisco.com/auth/v2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.sse.cisco.com/policies/v2/destinationlists?limit=1",
  },
});
